import { createContext } from "react";

const ItinerariesContext = createContext();

export default ItinerariesContext;
